// extracted by mini-css-extract-plugin
export default {"Title":"GrillConfiguration_Title__xtCfL","Row":"GrillConfiguration_Row__QqzM+","Description":"GrillConfiguration_Description__57JK0"};